import React from 'react'
import { connect } from 'react-redux'
import Icofont from 'react-icofont'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const WellDone = ({ project: { id } = { id: null }, projectId = null }) => {
  const { t } = useTranslation(['WellDone', 'ProjectsPage'])

  return (
    <div className="d-flex flex-column flex-fill justify-content-center align-items-center text-muted">
      <Icofont
        className="mb-5"
        icon="thumbs-up"
        size="9"
      />

      <p className="lead">
        {t('text', { ns: 'WellDone' })}
      </p>

      <Link
        className="btn btn-outline-secondary"
        to={`/projects/${id || projectId}`}
      >
        {t('links.back', { ns: 'ProjectsPage' })}
      </Link>
    </div>
  )
}

WellDone.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  projectId: PropTypes.string
}

const mapStateToProps = ({
  projects: {
    item: project
  }
}) => ({
  project
})

export default connect(mapStateToProps)(WellDone)
